var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "landing-page"
  }, [_vm.from === 'product-details' ? _c('h4', {
    ref: "mainHeader",
    staticClass: "main-header"
  }, [_c('span', {
    staticClass: "breadcrumb-link",
    on: {
      "click": function ($event) {
        return _vm.goTo('products');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('products')))]), _vm._v(" > "), _c('span', {
    staticClass: "breadcrumb-link",
    on: {
      "click": function ($event) {
        return _vm.goToProductDetails('info');
      }
    }
  }, [_vm._v(_vm._s(this.product.name))]), _vm._v(" > "), _c('span', {
    staticClass: "breadcrumb-link",
    on: {
      "click": function ($event) {
        return _vm.goToProductDetails('redirection');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('scan_destination')))]), _vm._v(" > " + _vm._s(this.config.name) + " ")]) : _vm._e(), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }), _vm.loadIframe ? _c('iframe', {
    style: {
      height: _vm.iframeHeight,
      maxHeight: _vm.iframeHeight
    },
    attrs: {
      "id": "stc-frame",
      "frameborder": "0",
      "src": _vm.editorUrl
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }